/**
 * Usage Reports Models
 * Data models for usage reports and statistics
 */

export interface UsageStats {
  documentsProcessed: number;
  successRate: number;
  creditsUsed: number;
  totalCost: number;
  documentsChange: number | null;
  successRateChange: number | null;
  creditsChange: number | null;
  costChange: number | null;
}

export interface DailyUsage {
  date: string;
  count: number;
  label: string;
}

export interface ProcessingLog {
  id: string;
  dateTime: string;
  documentName: string;
  template: string;
  pages: number;
  credits: number;
  status: 'success' | 'failed' | 'processing';
  processingTime: string;
}

export interface UsageReportFilters {
  dateRange: string;
  template: string;
  status: string;
  search: string;
}

export interface UsageReportState {
  stats: UsageStats | null;
  dailyUsage: DailyUsage[];
  processingLogs: ProcessingLog[];
  filters: UsageReportFilters;
  totalLogs: number;
  currentPage: number;
  pageSize: number;
  loading: boolean;
  exporting: boolean;
  error: string | null;
}

export const initialUsageReportState: UsageReportState = {
  stats: null,
  dailyUsage: [],
  processingLogs: [],
  filters: {
    dateRange: 'last30',
    template: 'all',
    status: 'all',
    search: ''
  },
  totalLogs: 0,
  currentPage: 1,
  pageSize: 10,
  loading: false,
  exporting: false,
  error: null
};

